<template>
    <transition
        name="slide-down">
        <header class="app-header-wrapper">
            <div class="app-header-left">
                <v-menu offset-y v-for="(item, index) in menuInfo">
                  <v-btn class="menu-btn"  slot="activator" :class="{'active': index === activeIndex}">{{ item.label }}
                    <i aria-hidden="true" class="material-icons icon input-group__append-icon input-group__icon-cb" v-if="index === activeIndex">arrow_drop_up</i>
                    <i aria-hidden="true" class="material-icons icon input-group__append-icon input-group__icon-cb" v-else>arrow_drop_down</i>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="subItem in item.lists" :key="item.title" @click.prevent="closeAndGo(subItem.link,index)" :class="{'active': fullPath === subItem.link}" :href="'#'+subItem.link">
                      <v-list-tile-title>{{ subItem.label }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <div class="changeStyle">
                    <v-menu offset-y>
                      <v-btn class="menu-btn"  slot="activator">
                          <img src="../assets/skin.png" alt="">                        
                      </v-btn>
                      <v-list>
                        <v-list-tile v-for="item in styleSchema" :key="item" href="javascript:;" @click.prevent="changeStyle(item)">
                          <v-list-tile-title :class='["style-schema", item === initSkin ? "active": "" ]'>
                              <div :class='["style-schema-item", item]'></div>
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>    
                </div>
            </div>
        </header>
    </transition>
</template>

<script>
import {mapState} from 'vuex';
import EventBus from '@/event-bus';
import menuInfo from '@/config/menu.js'

export default {
    name: 'appHeader',
    data () {
        return {
            menuInfo,
            fullPath: '',
            activeIndex: 1,
            styleSchema: ['blue','black','red','green'],
            initSkin: ''
        }
    },
    computed: {
        ...mapState('appShell/appSidebar', [
            'blocks'
        ]),
        ...mapState('appShell', [
            'isPageSwitching'
        ])
    },
    watch: {
        '$route': function(route) {
            this.fullPath = route.path
        }
    },
    beforeMount () {
        this.fullPath = this.$route.path
        this.initSkin = window.localStorage.getItem('skin') || 'blue'
        this.menuInfo.map((menuItem,menuItemIndex) => {
            menuItem.lists.map((listItem, listItemIndex) => {
                if (this.fullPath === listItem.link) {
                    this.activeIndex = menuItemIndex
                }
            })
        })
    },
    methods: {
        /**
         * 处理按钮点击事件
         *
         * @param {string} source 点击事件源名称 menu/logo/action
         * @param {Object} data 随点击事件附带的数据对象
         */
        handleClick(source, {actionIdx, route} = {}) {

            // 页面正在切换中，不允许操作，防止滑动效果进行中切换
            if (this.isPageSwitching) {
                return;
            }
            let eventData = {};

            // 点击右侧动作按钮，事件对象中附加序号
            if (source === 'action') {
                eventData.actionIdx = actionIdx;
            }

            // 发送给父组件，内部处理
            this.$emit(`click-${source}`, eventData);

            // 发送全局事件，便于非父子关系的路由组件监听
            EventBus.$emit(`app-header:click-${source}`, eventData);

            // 如果传递了路由对象，进入路由
            if (route) {
                this.$router.push(route);
            }
        },
        closeAndGo(route,index) {
            this.$router.push(route);
            this.fullPath = route
            this.activeIndex = index
        },
        changeStyle(style) {
            window.localStorage.setItem('skin', style)
            this.initSkin = style
            document.getElementById('app').className = `theme ${style}`
        }
    }
};
</script>

<style lang="stylus" >
    @import '~@/assets/styles/variables';
    @import '~vuetify/src/stylus/settings/_colors';

    $theme := {
        primary: #14a1e3
        accent: $blue.accent-2
        secondary: $grey.darken-3
        info: $blue.base
        warning: $amber.base
        error: $red.accent-2
        success: $green.base
    }

    $material-custom := {
        bg-color: #fff
        fg-color: #000
        text-color: #000
        primary-text-percent: 0.87
        secondary-text-percent: 0.54
        disabledORhints-text-percent: 0.38
        divider-percent: 0.12
        active-icon-percent: 0.54
        inactive-icon-percent: 0.38
    }
    $material-theme := $material-custom


$btn-color = #fff

        
.head-logo
    float left
    img
        height 60px
        padding 10px 20px
        // background url("../assets/head-logo.png") 0 0 no-repeat
    a:hover
        background #fff!important
        color #2A85DA!important
.app-header-wrapper
    height $app-header-height  
    color $btn-color
    padding 0
    box-shadow 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px rgba(0,0,0,.14), 0 1px 10px rgba(0,0,0,.12)
    transition transform 0.3s ease-out
    .app-header-left
        position relative
        .btn__content
            padding 0 8px
    .input-group__icon-cb
        color #fff!important
        font-size 18px
    .menu
        .menu__activator button
            height 52px
            margin 0
    &.slide-down-enter,
    &.slide-down-leave-to
        transform translate(0, -100%)

    & > div
        display flex
        align-items center
        overflow auto

    .app-header-middle
        flex 1
        font-size 1.2em

    // 改变 icon 大小
    .app-header-icon
        color $btn-color
        width 20px
        height 20px
.app-header-wrapper .menu .menu__activator button
    height 60px
.menu__activator .btn 
    box-shadow none!important
.menu-btn.btn
    color #fff!important
.theme--light .menu-btn.btn
    background none!important
.changeStyle
    position absolute
    right 0px
.list__tile__title.style-schema
    width 30px
    height 30px
    border-radius 30px
    margin 0 auto
    &.active
       border 1px solid #ddd
.style-schema-item
    width 20px
    height 20px
    border-radius 20px
    margin  3.5px
</style>



// WEBPACK FOOTER //
// AppHeader.vue?4a0eebd5